import React from 'react';
import { _cs } from '@togglecorp/fujs';
import RawButton from '../../RawButton/index.js';
import { genericMemo, ymdToDateString } from '../../../utils/index.js';
import styles from './styles.css.js';

function CalendarDate(props) {
  const {
    className,
    year,
    month,
    date,
    currentYear,
    currentMonth,
    currentDate,
    onClick,
    elementRef,
    activeDate,
    ghost
  } = props;
  const handleClick = React.useCallback(() => {
    if (onClick) {
      onClick(year, month, date);
    }
  }, [year, month, date, onClick]);
  const dateString = ymdToDateString(year, month, date);
  return /*#__PURE__*/React.createElement(RawButton, {
    elementRef: elementRef,
    name: date,
    className: _cs(styles.date, year === currentYear && month === currentMonth && currentDate === date && styles.today, dateString === activeDate && styles.active, ghost && styles.ghost, className),
    onClick: handleClick
  }, date);
}

var CalendarDate$1 = genericMemo(CalendarDate);

export { CalendarDate$1 as default };
//# sourceMappingURL=index.js.map
